import React, { useState } from "react";
import ManageCard from "./components/ManageCard";
import FooterButton from "../FooterButton";
import { useupdateNotifications } from "hooks/api/useSettings";
import Skeleton from "components/BaseWidgets/skeleton";
import { useQueryClient } from "@tanstack/react-query";
import { NotificationLabels } from "./helper";

function Notification({ data, isLoading }) {
  const queryClient = useQueryClient();
  const [toggles, setToggles] = useState([]);
  const { mutate: updateNotifications, isLoading: updateLoading } =
    useupdateNotifications({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["account_settings"] });
      },
    });
  const buildPayload = () => {
    const validKeys = Object.keys(NotificationLabels).map(Number);

    return toggles
      .filter((item) => validKeys.includes(item.notification_type))
      .map((item) => ({
        notification_type: item.notification_type,
        push: item.push ? 1 : 2,
        sms: item.sms ? 1 : 2,
        email: item.email ? 1 : 2,
      }));
  };

  return (
    <div className="tab-content">
      <h1 className="tab-title ">Notifications</h1>
      {isLoading ? (
        <Skeleton label={false} height={255} />
      ) : (
        <ManageCard
          data={data?.notification_settings?.slice(
            0,
            data?.notification_settings?.length,
          )}
          onChange={setToggles}
        />
      )}
      <FooterButton
        onSave={() => {
          const payload = buildPayload();
          updateNotifications(payload);
        }}
      />
    </div>
  );
}

export default Notification;
